import React from 'react';
import { connect } from 'react-redux';
import { LinearProgress, Typography } from '@mui/material';
import ReactEcharts from '../../lazy/Echarts';
import { Row } from '../../util/Page';
import { getBuildingField } from '../../../redux/selectors/buildings';
import { getIngestStatsForBuilding } from '../../../redux/selectors/ingestStats';
import { graphDateString, roundDateToHour, dateTime } from '../../../utils/parsing';

import './ingest-timeseries.css';

const getOptions = ({ series, timestamps, timezone }) => ({
  animation: false,
  tooltip: {
    trigger: 'axis',
    formatter: (params) => {
      let tooltip = `<div>${dateTime(params[0].axisValue, timezone)}`;
      // make the tooltip markers draw in the same order as the stacked bar graphs
      params
        .slice()
        .reverse()
        .forEach((p) => {
          tooltip += `<br /> ${p.marker}${p.seriesName}: ${(
            p.value[1] || 0
          ).toLocaleString()} points`;
        });
      tooltip += '</div>';
      return tooltip;
    },
  },
  grid: {
    top: 30,
    bottom: 15,
    left: 10,
    right: 20,
    containLabel: true,
  },
  xAxis: {
    type: 'time',
    name: 'Date',
    nameLocation: 'center',
    nameGap: 35,
    data: timestamps,
    splitLine: { show: false },
  },
  yAxis: {
    type: 'value',
    position: 'left',
    name: 'Points per hour',
    splitLine: { show: false },
  },
  color: ['#4d9de0'],
  series,
});

const PointIngestTimeseries = (props) => {
  const { loaded, isEmpty } = props;
  let inner;
  if (!loaded) {
    inner = <LinearProgress className="loader" color="secondary" />;
  } else if (isEmpty) {
    inner = <Typography variant="h5">No buildings with ingest data yet</Typography>;
  } else {
    inner = <ReactEcharts notMerge style={{ height: '490px' }} option={getOptions(props)} />;
  }
  return <Row className="point-ingest-timeseries">{inner}</Row>;
};

export default connect((state, { buildings }) => {
  const {
    entities: {
      buildings: { byId },
      ingestStats: { loaded },
    },
  } = state;
  // build up a dict-of-dicts of the ingest data by rounded timestamp and building id
  // values are the sum of all entries for the timestamp
  /* eslint-disable no-param-reassign */
  const dataByTsBuilding = buildings.reduce((data, bid) => {
    const stats = getIngestStatsForBuilding(state, bid);
    stats.forEach((s) => {
      const ts = graphDateString(roundDateToHour(s.timestamp));
      if (data[ts] == null) data[ts] = {};
      data[ts][bid] = (data[ts][bid] || 0) + s.num_points;
    });
    return data;
  }, {});
  /* eslint-enable */
  const timestamps = Object.keys(dataByTsBuilding);
  const isEmpty = timestamps.length === 0;
  timestamps.sort();
  // one series per building, and each hour has a data entry or is empty
  const series = buildings.map((bid) => ({
    name: byId[bid]?.name,
    type: 'bar',
    stack: `${byId[bid]?.orgId}`, // admin view will show a stack per organization
    data: timestamps.map((ts) => [ts, dataByTsBuilding[ts][bid]]),
  }));
  const timezone = getBuildingField(state, buildings[0], 'timezone');
  return { series, timestamps, loaded, isEmpty, timezone };
})(PointIngestTimeseries);
